import { List, Typography } from "@mui/material";

import { useAttachmentsData } from "src/context/AttachmentsContext";
import AttachmentListItem from "./Attachments_list_ListItem";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import AttachmentViewerModal from "src/components/AttachmentViewer/AttachmentViewerModal";
import PropTypes from "prop-types";

export default function Attachments_list({
  deAttachOnDelete = false,
  openAttachmentOnClick = true,
  allowDelete = false,
}) {
  const { isLoading, attachmentList, selectedAttachment, setSelectedAttachment } =
    useAttachmentsData();

  return (
    <>
      <AttachmentViewerModal
        open={openAttachmentOnClick && selectedAttachment != null}
        onClose={() => setSelectedAttachment(null)}
        attachmentId={selectedAttachment?.attachmentId}
      />
      <div
        className="center"
        style={{
          display: "flex",
          border: "1px solid gray",
          borderRadius: 5,
          minWidth: "400px",
        }}>
        {attachmentList?.length === 0 ? (
          <>
            <Typography variant="body" color="secondary" sx={{ padding: 2 }}>
              Ei tiedostoja
            </Typography>
          </>
        ) : (
          <List dense sx={{ width: "100%", padding: 0 }}>
            {attachmentList?.map((attachment) => (
              <AttachmentListItem
                key={attachment.attachmentId}
                attachment={attachment}
                deAttachOnDelete={deAttachOnDelete}
                allowDelete={allowDelete}
              />
            ))}
          </List>
        )}
      </div>
      <ProgressBar show={isLoading} style={{ marginTop: 5 }} />
    </>
  );
}

Attachments_list.propTypes = {
  deAttachOnDelete: PropTypes.bool,
  openAttachmentOnClick: PropTypes.bool,
  allowDelete: PropTypes.bool,
};
